import { Suspense, lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import memberRouter from './memberRouter';
import mypageRouter from './mypageRouter';
import adminRouter from './adminRouter';
import communityFrontRouter from '../community/router/communityMainRouter';

import MemberListPage from '../pages/MemberListPage';
import curriculumRouter from './curriculumRouter';
import memberSearchRouter from './memberSearchRouter';

const Loading = <div>Loading....</div>;
const Main = lazy(() => import('../pages/MainPage'));

const root = createBrowserRouter([
  {
    path: '',
    element: (
      <Suspense fallback={Loading}>
        <Main />
      </Suspense>
    ),
  },

  {
    path: 'member',
    children: memberRouter(),
  },
  {
    path: 'mypage',
    children: mypageRouter(),
  },
  {
    path: 'admin',
    children: adminRouter(),
  },
  {
    path: 'community',
    children: communityFrontRouter(),
  },
  {
    path: 'curriculum',
    children: curriculumRouter(),
  },
  {
    path: 'memberSearch',
    children: memberSearchRouter(),
  },
  {
    path: 'memberListAll',
    element: (
      <Suspense fallback={Loading}>
        <MemberListPage />
      </Suspense>
    ),
  },
]);

export default root;
